import { createStore } from './store';

// What you opened lately, on this device, for the "Recent" group of the search palette.

export interface RecentItem {
  kind: 'person' | 'company' | 'deal' | 'finder' | 'thread';
  id: string;
  title: string;
  subtitle?: string | null;
  hue?: number;
  /** Companies: their logo. */
  logo?: string | null;
}

const KEY = 'clientbook.recent';
const MAX = 6;

function load(): RecentItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as RecentItem[]) : [];
    return Array.isArray(parsed) ? parsed.filter((x) => x && typeof x.id === 'string').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export const recentStore = createStore<{ items: RecentItem[] }>({ items: load() });

export function rememberRecent(item: RecentItem): void {
  const items = [item, ...recentStore.get().items.filter((x) => !(x.kind === item.kind && x.id === item.id))].slice(0, MAX);
  recentStore.set({ items });
  try {
    localStorage.setItem(KEY, JSON.stringify(items));
  } catch {
    /* Storage full or blocked: recents simply stay for this visit. */
  }
}

export function forgetRecent(kind: RecentItem['kind'], id: string): void {
  const items = recentStore.get().items.filter((x) => !(x.kind === kind && x.id === id));
  recentStore.set({ items });
  try {
    localStorage.setItem(KEY, JSON.stringify(items));
  } catch {
    /* ignore */
  }
}

/** Clears this device's recents, used when signing out so the next person starts fresh. */
export function clearRecent(): void {
  recentStore.set({ items: [] });
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
